export const theme = {
  colours: {
    black: '#373737',
    white: 'white',
    purple: '#cd6aff',

    lightBlue: '#e8f1ff',
    brightBlue: '#b4e2ff',
    mediumBlue: '#92b5e9',
    blue: '#7ba2e9',

    lightGreen: '#e7fff3',
    mediumGreen: '#80c3b3',
    darkGreen: '#006838',

    lightOrange: '#ffeae7',
    mediumOrange: '#e0998a',
    orange: '#f16522',

    lightGrey: '#e8e8e9',
    grey: '#dddedf',

    // Links
    link: '#0000ee',
    visited: '#551a8b',
    // Accessibility and forms
    focus: '#4fcd90',
    error: '#d0021b',
  },
  breakpoints: {
    sm: 'min-width: 576px',
    md: 'min-width: 768px',
    lg: 'min-width: 992px',
    xl: 'min-width: 1200px',
  },
  typography: {
    base: 1.6,
    scale: {
      xs: 1.2,
      sm: 1.2,
      md: 1.2,
      lg: 1.2,
    }
  },
  typeStyles: ( exp ) => {
    return `font-size: ${theme.typography.base * Math.pow( theme.typography.scale.xs, exp )}rem;
    @media ( ${theme.breakpoints.sm} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.sm, exp )}rem;
    }
    @media ( ${theme.breakpoints.md} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.md, exp )}rem;
    }
    @media ( ${theme.breakpoints.lg} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.lg, exp )}rem;
    }`
  },
  showSmall: () => {
    return `@media(${theme.breakpoints.sm}) {
      display: none;
    }`
  },
  showLarge: () => {
    return `display: none;
    @media(${theme.breakpoints.sm}) {
      display: block;
    }`
  }
};
